import React,{ useState, useEffect } from 'react';
import {HtmlParse} from 'utils';
import Link from 'components/Link';
import helpCenter from 'images/help-center/cencommerce-help-center.svg';
import whatsappIcon from 'images/icons/whatsapp_dark_icon.svg';
import { actionsType, header, preheaderDropdown, ecommerce, preheaderOurPrograms } from 'config/constants';
import LoginService from "services/Login/";
import StorageService from 'services/StorageService';
import { useViewportMediaQuery } from 'hooks';
import {features} from 'config';
import PubSub from 'services/PubSub';
import TagManagerService from 'services/TagManager';
import style from './style.scss';//NOSONAR

let actions = [];
let timeMouseEnter = null;

const PreHeader = () => {
    const [userIsPrime,setUserPrime] = useState(false);
    const [open, setOpen] = useState(false);
    const [openOurPrograms, setOpenOurPrograms] = useState(false);

    const isMobile = useViewportMediaQuery('1024');

    const newVariant = !isMobile;
    
    const setUserIsPrime = () => {
        const dataUser = StorageService.getSecureItem('userData');
        setUserPrime(LoginService.isPrime() || (features.primeService && dataUser && !!dataUser['CencoPrime_CAT']))
    }

    useEffect(() => {
        setUserIsPrime()
        actions.push(PubSub.register('toggle_preheader', () => setOpen(false)));

        actions.push(PubSub.register(actionsType.LOGGED_IN, ()=> {
            setUserIsPrime()
        }));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    },[]);

    const closeDrawer = (action = null, tag= null, category= null) => {
        PubSub.dispatch(actionsType.DRAWER.MINICART_CLOSE)
        PubSub.dispatch('toggle_menu', { state: false })
        PubSub.dispatch('toggle_notify', { state: false })
        PubSub.dispatch('toggle_minicart', { state: false });
        action && tag && category && clickPreHeader(action, tag, category);
    }

    const _openInfo = (cencosudCard) => {
        if(cencosudCard) {
            setOpen(!open);
            setOpenOurPrograms(false)
        }else {
            setOpenOurPrograms(!openOurPrograms)
            setOpen(false);
        }
        closeDrawer();
    }

    const setDropdownVisible = (isVisible) => {
        clearTimeout(timeMouseEnter);

        if (isVisible) {
            timeMouseEnter = setTimeout(() => {
                setOpen(true);
                setOpenOurPrograms(true);
            }, 100);
        } else {
            setOpenOurPrograms(false);
            setOpen(false);
        }
    };

    const clickPreHeader = (action, tag, category) => {
        TagManagerService.interaction(action, tag, category);
    }

    const openDrawer = (action, tag, category) => {
        PubSub.dispatch(actionsType.DRAWER.INVITATION_PRIME_OPEN);
        TagManagerService.interaction(action, tag, category);
    }
    

    return(
        <div className={"pre-header-wrapper " + (newVariant ? ' variant' : '') + (isMobile ? ' no-mobile' : '') + (userIsPrime ? ' is-prime' : '')} >
            <div className={"pre-header-container "}>
                {!isMobile && <div className={'pre-header-content-left-wrap'}>
                    <Link className={"pre-header-link " + header.classNameEcommerce} to={header.linkEcommerce} target='_blank' onClick={() => clickPreHeader('Click', 'Santa Isabel' , 'Pre header')}>
                        {newVariant && <i className={header.iconEcommerce}></i>}
                        {!newVariant && <span>{header.nameEcommerce}</span>}
                    </Link>
                    <Link className="pre-header-link paris" to={header.paris} target='_blank' onClick={() => clickPreHeader('Click', 'Paris' , 'Pre header')}>
                        {newVariant && <i className="jumbo-icon-preheader-paris"></i>}
                        {!newVariant && <span>Paris</span>}
                    </Link>
                    <Link className="pre-header-link  easy " to={header.easy} target='_blank' onClick={() => clickPreHeader('Click', 'Easy' , 'Pre header')}>
                        {newVariant && <i className="jumbo-icon-preheader-easy"></i>}
                        {!newVariant && <span>Easy</span>}
                    </Link>

                    {!ecommerce.whiteLabel && <div className={"pre-header-link nuestros-programas "} onClick={() => _openInfo(false)}>
                        <span className="pre-header-link-title">Nuestros destacados</span>
                        <i className="pre-header-arrow-down font-icn arrow-up"></i>

                        {!isMobile && <div className={'pre-header-dropdown-arrow-up nuestros-programas' + (openOurPrograms ? ' show-our-programs' : '')}></div>}
                        {!isMobile && <div className={"pre-header-dropdown nuestros-programas" + (openOurPrograms ? ' show ' : '')} onMouseLeave={() => setDropdownVisible(false)}>
                            <ul className="pre-header-dropdown-list">
                                {preheaderOurPrograms && preheaderOurPrograms.map((item, i) => {
                                    return (
                                        <li key={i} className="pre-header-dropdown-item nuestros-programas">
                                            <Link className='pre-header-dropdown-link nuestros-programas' to={item.link} target='_blank' onClick={() => clickPreHeader('Click', item.title , 'Pre header')}><i className={"pre-header-dropdown-icon " + item.icon}></i></Link>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>}
                    </div>}

                    {!ecommerce.whiteLabel && <div className={"pre-header-link jumbo-prime "} onClick={() => openDrawer('Click','Jumbo Prime','Pre Header')}>Jumbo Prime</div>}

                    <Link className="pre-header-link " to={header.cencosudPoints} target='_blank' onClick={() => clickPreHeader('Click', 'Puntos Cencosud' , 'Pre header')}><span>Puntos Cencosud</span>
                    </Link>


                    <div className={"pre-header-link tarjeta-cencosud "} onClick={() => _openInfo(true)}>
                        {!newVariant && <i className="jumbo-icon-preheader-payment"></i>}
                        <span className="pre-header-link-title">Tarjeta Cencosud</span>
                        <i className="pre-header-arrow-down font-icn arrow-up"></i>
                    </div>
                </div>}

                <div className={'pre-header-content-right-wrap '}>
                    {!ecommerce.whiteLabel && isMobile && <div className={"pre-header-link jumbo-prime "} onClick={() => openDrawer('Click','Jumbo Prime','Pre Header')}>Jumbo Prime</div>}
                    {userIsPrime && <Link className="pre-header-link whatsapp" to={header.whatsappPrime} target='_blank' onClick={() => clickPreHeader('Click', 'Whatsapp Prime' , 'Pre header')}>
                        {!newVariant && <i className="whatsapp-icon">{HtmlParse(whatsappIcon)}</i>}
                        <span>WhatsApp</span>
                    </Link>}
                    {!userIsPrime && <Link className={"pre-header-link tracking "} to='/mis-compras' onClick={() => closeDrawer('Click', 'Estado del pedido' , 'Pre header')}>Estado del pedido</Link>}
                    {(ecommerce.whiteLabel === true) && <Link className={"pre-header-link locales "} to='/locales' onClick={() => closeDrawer('Click', 'Locales' , 'Pre header')}>Locales</Link>}
                    <Link className={"pre-header-link help-center-link "} to={header.helpCenterLink} target='_blank' onClick={() => clickPreHeader('Click', 'Centro de ayuda' , 'Pre header')}>
                        {!newVariant && <i className="helpcenter-icon">{HtmlParse(helpCenter)}</i>}
                        <span>Centro de ayuda</span>
                    </Link>
                </div>

                {!isMobile && <div className={'pre-header-dropdown-arrow-up' + (open ? ' show' : '')}></div>}
                {!isMobile && <div className={"pre-header-dropdown " + (open ? ' show ' : '')} onMouseLeave={() => setDropdownVisible(false)}>
                    <ul className="pre-header-dropdown-list">
                        {preheaderDropdown && preheaderDropdown.map((item, i) => {
                            return (
                                <li key={i} className="pre-header-dropdown-item">
                                    <i className={"pre-header-dropdown-icon " + item.icon}></i>
                                    <Link to={item.link} target='_blank' onClick={() => clickPreHeader('Click', item.title , 'Pre header')}><span dangerouslySetInnerHTML={{__html: item.title}}></span></Link>
                                </li>
                            )
                        })}
                    </ul>
                </div>}
            </div>

        </div>
    )
}

export default PreHeader;
